import { getUrl, Request } from "../../request";

export const getUserBills = () => {
  return Request.get(getUrl("/api/v1/service_center/user-bills/"));
};

export const getUserBill = (code) => {
  return Request.get(getUrl("/api/v1/service_center/bill-factor/"), {
    code,
  });
};

export const getServiceCenters = (type_id, city_id) => {
  return Request.get(getUrl("/api/v1/service_center/"), {
    type_id,
    city_id,
  });
};

export const getServiceCenterTypes = (city_id) => {
  return Request.get(getUrl("/api/v1/service_center/types/"), {
    city_id,
  });
};

export const getCustomerInfo = (mobile_number) => {
  return Request.get(getUrl("/api/v1/service_center/load-customer-info/"), {
    mobile_number,
  });
};

export const getCouponOrders = (mobile_number) => {
  return Request.get(getUrl("/api/v1/service_center/load-orders/"), {
    mobile_number,
  });
};

export const postCustomerInfo = (first_name, last_name, mobile_number) => {
  return Request.post(getUrl("/api/v1/service_center/load-customer-info/"), {
    first_name,
    last_name,
    mobile_number,
  });
};

export const postServiceInfo = (
  mobile_number,
  order_line_id,
  current_kilometer,
  user_car_id,
  is_coupon,
  messaging_service,
  extra_charge
) => {
  return Request.post(getUrl("/api/v1/service_center/submit-service/"), {
    mobile_number,
    order_line_id,
    current_kilometer,
    user_car_id,
    is_coupon,
    messaging_service,
    extra_charge
  });
};


export const postPlateImage = (user_car_id, mobile_number, plate_image) => {
  const formData = new FormData();
  formData.append("user_car_id", user_car_id);
  formData.append("mobile_number", mobile_number);
  formData.append("plate_image", plate_image, plate_image.name);

  return Request.formPost(
    getUrl("/api/v1/service_center/upload-car-plate-image/"),
    formData
  );
};

export const getPlateImage = (user_car_id, mobile_number) => {
  return Request.get(
    getUrl("/api/v1/service_center/upload-car-plate-image/"),
    {
      user_car_id,
      mobile_number,
    }
  );
};

export const postOtpValidation = (code, mobile_number, bill_id) => {
  return Request.post(getUrl("/api/v1/service_center/submit-service/"), {
    code,
    mobile_number,
    bill_id,
  });
};

export const resendOtpValidation = (mobile_number, messaging_service) => {
  return Request.post(getUrl("/api/v1/service_center/resend-otp/"), {
    mobile_number,
    messaging_service,
  });
};

export const getServices = ({ is_verified, q }) => {
  return Request.get(getUrl("/api/v1/service_center/load-bills/"), {
    ...(is_verified && { is_verified }),
    ...(q && { q }),
  });
};

export const getServiceDetails = (id) => {
  return Request.get(getUrl(`/api/v1/service_center/load-bills/${id}/`));
};

export const deleteServiceDetails = (id) => {
  return Request.del(getUrl(`/api/v1/service_center/load-bills/`), {
    bill_id: id,
  });
};